import styled from 'styled-components'

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
`
